import { Empleado } from './empleado';
import { Archivo } from './archivo';

export class TicketInfo {
  idEfectivoReembolsable: number = 0;
  numero: string;
  folio: string;
  fecha: Date;
  concepto: string;
  comentario: string;
  monto: number;
  pagado: boolean;
  autorizadoContabilidad: boolean;
  autorizadoJefatura: boolean;
  noDeducible: boolean;
  fechaPago: Date;
  fechaAutorizacionPago?: Date;
  fechaContabilidad?: Date;
  fechaJefatura?: Date;
  idBeneficiario: number;
  idEmpleado: number;
  idEmpleadoPago: number;
  idOrdenServicio: number;
  idSucursal: number;
}

export class Ticket extends TicketInfo {
  sucursal: string;
  ordenServicio: string;
  empleado: Empleado;
  empleadoPago?: Empleado;
  empleadoContabilidad?: Empleado;
  empleadoJefatura?: Empleado;
  comprobante: Archivo;
  comprobantePago: Archivo;
  selected: boolean;
  beneficiario: Beneficiario;
}

export class Beneficiario {
    idBeneficiario: number;
    nombre: string;
    cuenta: string;
    clabe: string;
    banco: string;
    diasCredito: number;
    selected: boolean;
}

export class OrdenServicioReembolsable {
    idOrdenServicio: number;
    ordenServicio: string;
    selected: boolean;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/efectivoReembolsable.ts